import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class RestoreService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;

  restoreData(formData: any, confirmString: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "management/restoredata?confirmString=" + confirmString, formData).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

}